import cx from "clsx";
import SizingContainer from "common-utils/components/SizingContainer";
import { FileHandle } from "kreate-common/modules/business-types";
import React from "react";
import { MdPerson } from "react-icons/md";

import styles from "./index.module.scss";

import { ImageViewer } from "@/modules/kreate-components/components/ImageViewer";

type Props = {
  className?: string;
  style?: React.CSSProperties;
  avatar: FileHandle | null | undefined;
};

export default function AvatarViewer({ className, style, avatar }: Props) {
  return (
    <SizingContainer
      className={cx(styles.container, className)}
      style={style}
      sizing={{ type: "fixed", width: "56px", height: "56px" }}
      background={avatar ? "default" : "none"}
    >
      {avatar ? (
        <ImageViewer
          style={{ backgroundColor: "transparent" }}
          sizing="fill"
          value={avatar}
          sizes="56px"
          objectFit="cover"
        />
      ) : (
        <div className={styles.placeholder}>
          <MdPerson size="20px" />
        </div>
      )}
    </SizingContainer>
  );
}
